import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LinkIcon from '@mui/icons-material/Link';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SendIcon from '@mui/icons-material/Send';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Paper,
  Divider,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { SERVER_DATE_FORMAT, UI_TIME_ZONE } from 'src/constants/formats';
import { archLevel } from 'src/data/config';
import { useLazyGetEtmfDocDetailsByTmfDocumentIdQuery } from 'src/services/etmfDocLevel';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { EmailActivity } from '../EmailActivity';
import { useIssueLog } from '../IssueLog/useIssueLog';
import '../StudyLogs.scss';
import { useSIVConfirmationLetter } from './useSIVConfirmationLetter';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { MainRTE } from '@pihealth/common-ui-library';
import StaticJson from '../../../../resources/static.json';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import Loader from 'src/components/common/Loader';

interface ISIConfirmation {
  siteStudyPersonnelsData: any;
  sivVisitData: any;
  sivLetterData: any;
  setSIVConfirmLetterOpen: (isSivOpen: boolean) => void;
  setStudyLogOpen: (isStudyLogOpen: boolean) => void;
  selectedRow: any;
  setNTFGrid: any;
  setopenSIVConfLetter: any;
}
const SiteInitiationConfirmationLetter = (props: ISIConfirmation) => {
  const {
    siteStudyPersonnelsData,
    sivLetterData,
    setSIVConfirmLetterOpen,
    setStudyLogOpen,
    selectedRow,
    setNTFGrid,
    setopenSIVConfLetter
  } = props;
  const { unSavedWarning } = useFieldTranslation();
  const { getPreferredDateInLocal, userPreferedDateFormat, preferedFormatForDatePicker } = usePreferedDateFormat();
  const dateFormat = userPreferedDateFormat.toUpperCase();
  const { checkPermission } = usePermissionWrapper();
  const updateSICLPermission = checkPermission('update_si_confirmationletter');
  const publishSIVCLPermission = checkPermission('publish_siv_confirmationletter');
  const editSIVCLPermission = checkPermission('edit_siv_confirmation_letter');
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const sponsor = useAppSelector(state => state.user.user?.sponsor);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const email = useAppSelector(state => state.user.user?.email);
  const [isChanged, setIsChanged] = useState(false);
  const { user: userFullName } = useUser();
  const [salulationErr, setSalulationErr] = useState(false);
  const [openEmailPopoup, setOpenEmailPopoup] = useState(false);
  const [openRTE, setOpenRTE] = useState(false);
  const [openRTEContent, setOpenRTEContent] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');
  const [disableEditContent, setDisableEditContent] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [openVersionPopup, setOpenVersionPopup] = useState(false);
  const { selectedAppSection } = useSelectedAppInfo();

  const phoneNumberLetter = siteStudyPersonnelsData?.personnel
    .map((items: { site_per_email: string | undefined; site_per_phone: any }) => {
      if (items.site_per_email?.toLowerCase() === email?.toLowerCase()) {
        return items.site_per_phone;
      }
    })
    .filter((item: any) => item);

  const [sivCLDetails, setSIVCLDetails] = useState(sivLetterData);
  const [sivCLDetailsError, setSIVCLDetailsError] = useState<any>({
    siv_visit_start_date: null,
    siv_visit_end_date: null
  });

  const {
    updateSivConfrimationLetter,
    updateSivConfrimationLetterIsLoading,
    updateSivConfrimationLetterIsError,
    updateSivConfrimationLetterError,
    updateSivConfrimationLetterIsSuccess,
    selectSivConfrimationLetter,
    selectSivConfrimationLetterData,
    selectSivConfrimationLetterIsSuccess,
    publishSivConfrimationLetter,
    publishSivConfrimationLetterIsLoading,
    publishSivConfrimationLetterIsError,
    publishSivConfrimationLetterError,
    publishSivConfrimationLetterIsSuccess,
    createNewVersion,
    createNewVersionIsLoading,
    createNewVersionIsError,
    createNewVersionError,
    createNewVersionIsSuccess
  } = useSIVConfirmationLetter();

  const [getDocumentOnTmfDocumentId, { data: documentOnTmfDocumentIdData }] =
    useLazyGetEtmfDocDetailsByTmfDocumentIdQuery();

  const dispatch = useAppDispatch();
  const [filteredIssues, setFilteredIssues] = useState([]);
  const { getIssueLogBasedOnDateRange } = useIssueLog();
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const isUpdatePublish = selectSivConfrimationLetterData?.visit_confirmation?.siv_confirmation_publish_version
    ? true
    : false;

  const handleBack = () => {
    if (isChanged) {
      setOpenConfirmExit(true);
    } else {
      setStudyLogOpen(false);
      setIsChanged(false);
      setNTFGrid(true);
      setopenSIVConfLetter(false);
    }
  };
  const handleChange = (e: any) => {
    setSIVCLDetails({
      ...sivCLDetails,
      visit_confirmation: { ...sivCLDetails?.visit_confirmation, [e.target.name]: e.target.value }
    });
    setSalulationErr(false);
    setIsChanged(true);
    setConfirmExitValue(dispatch, true);
  };
  // To open Send Modal
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [openImport, setOpenImport] = useState(false);
  const handleClickOpenImport = () => {
    setOpenImport(true);
    setSIVCLDetails({
      ...sivCLDetails,
      visit_confirmation: {
        ...sivCLDetails?.visit_confirmation,
        siv_visit_issue: selectedRow?.visit_name
      }
    });
    setConfirmExitValue(dispatch, true);
  };
  const handleCloseImport = () => {
    setOpenImport(false);
    setSIVCLDetailsError({ siv_visit_start_date: null, siv_visit_end_date: null });
  };

  const getSIVConfrimationLetterData = async () => {
    await selectSivConfrimationLetter({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      siv_visit_id: selectedRow?.id
    });
  };

  const getDocumentBasedTmfDocumentId = async (tpDocumentId: string) => {
    await getDocumentOnTmfDocumentId({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      tmfDocumentId: tpDocumentId,
      application: `${archLevel == 'sponsor' ? 'CTMS' : 'TSDA'}`,
      module_section_related: 'STUDY LOGS',
      parent_entity_related: selectedRow?.visit_name
    });
  };

  useEffect(() => {
    if (selectSivConfrimationLetterData?.visit_confirmation?.tp_document_id) {
      getDocumentBasedTmfDocumentId(selectSivConfrimationLetterData?.visit_confirmation?.tp_document_id);
    }
  }, [selectSivConfrimationLetterData?.visit_confirmation?.tp_document_id]);

  useEffect(() => {
    getSIVConfrimationLetterData();
  }, []);

  useEffect(() => {
    if (createNewVersionIsSuccess) {
      dispatch(hideLoader());
      dispatch(
        setMessage({
          msgDetails: 'New site initiation confirmation letter version ready to modify.',
          severity: 'success'
        })
      );
      setOpenVersionPopup(false);
      getSIVConfrimationLetterData();
      setOpenRTEContent(false);
      setDisableEditContent(false);
      setIsChanged(false);
    }
  }, [createNewVersionIsSuccess]);

  useEffect(() => {
    if (createNewVersionIsLoading) {
      dispatch(showLoader());
    }
  }, [createNewVersionIsLoading]);

  useEffect(() => {
    if (selectSivConfrimationLetterData) {
      setSIVCLDetails(selectSivConfrimationLetterData);
      setFilteredIssues(selectSivConfrimationLetterData?.issues);
    }
  }, [selectSivConfrimationLetterData, selectSivConfrimationLetterIsSuccess]);

  const validationOfRTE =
    selectSivConfrimationLetterData?.visit_confirmation?.siv_rte1 === '' ||
    selectSivConfrimationLetterData?.visit_confirmation?.siv_rte1 === null
      ? StaticJson.SIVconfirmationLetterRTE
      : selectSivConfrimationLetterData?.visit_confirmation?.siv_rte1;

  const handleSaveSIVCL = async () => {
    if (sivCLDetails?.visit_confirmation?.siv_salutation_letter) {
      dispatch(showLoader());
      const dataObj = {
        visit_confirmation: {
          visit_scheduled_date: new Date(selectedRow?.start_date),
          siv_cra_first_name: sivCLDetails?.visit_confirmation?.siv_cra_first_name
            ? sivCLDetails?.visit_confirmation?.siv_cra_first_name
            : userFullName,
          siv_cra_email_address: sivCLDetails?.visit_confirmation?.siv_cra_email_address
            ? sivCLDetails?.visit_confirmation?.siv_cra_email_address
            : email,
          siv_cra_phone_number: sivCLDetails?.visit_confirmation?.siv_cra_phone_number
            ? sivCLDetails?.visit_confirmation?.siv_cra_phone_number
            : phoneNumberLetter[0],
          siv_salutation_letter: sivCLDetails?.visit_confirmation?.siv_salutation_letter,
          siv_confirmation_sponsor_name: sivCLDetails?.visit_confirmation?.siv_confirmation_sponsor_name
            ? sivCLDetails?.visit_confirmation?.siv_confirmation_sponsor_name
            : sponsor,
          siv_confirmation_publish_version: 0,
          tp_document_meta_id: selectedRow?.id,
          tp_document_id: 'string',
          id: sivCLDetails?.visit_confirmation?.id,
          monitoring_visit_id: sivCLDetails?.visit_confirmation?.monitoring_visit_id,
          siv_visit_issue: sivCLDetails?.visit_confirmation?.siv_visit_issue,
          siv_visit_start_date: sivCLDetails?.visit_confirmation?.siv_visit_start_date,
          siv_visit_end_date: sivCLDetails?.visit_confirmation?.siv_visit_end_date,
          is_published: false,
          siv_rte1: htmlContent === '' ? validationOfRTE : htmlContent
        },
        issues: sivCLDetails?.issues,
        updated_by: userFullName
      };
      updateSivConfrimationLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        data: dataObj
      });
      dispatch(hideLoader());
      setConfirmExitValue(dispatch, false);
      setDisableBtn(false);
    } else {
      setSalulationErr(true);
      setConfirmExitValue(dispatch, true);
    }
  };

  const handleImportSumbit = async () => {
    setIsChanged(true);
    if (
      sivCLDetails?.visit_confirmation?.siv_visit_start_date !== 'Invalid Date' &&
      sivCLDetails?.visit_confirmation?.siv_visit_end_date !== 'Invalid Date' &&
      ((!!sivCLDetailsError?.siv_visit_start_date && !!sivCLDetailsError?.siv_visit_end_date) ||
        (sivCLDetails?.visit_confirmation?.siv_visit_start_date != null &&
          sivCLDetails?.visit_confirmation?.siv_visit_end_date != null))
    ) {
      const filteredIssues: any = await getIssueLogBasedOnDateRange({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        issue_level: 'SPONSOR',
        application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
        start_date: sivCLDetails?.visit_confirmation?.siv_visit_start_date,
        end_date: sivCLDetails?.visit_confirmation?.siv_visit_end_date
      });
      if (
        filteredIssues?.isSuccess &&
        filteredIssues?.data?.selected_data &&
        filteredIssues?.data?.selected_data.length > 0
      ) {
        const modifiedIssues: any = filteredIssues?.data?.selected_data.map((ele: any) => {
          return {
            id: ele.issue_details?.id,
            stdy_siv_subject_id: ele.issue_details?.subject_id,
            stdy_siv_issue_class: ele.issue_details?.issue_class,
            stdy_siv_issues: ele.issue_details?.issue,
            stdy_siv_category: ele.issue_details?.category,
            stdy_siv_action_description: ele.issue_details?.action_des,
            stdy_siv_action_due_date: ele.issue_details?.action_due
          };
        });
        setSIVCLDetails({ ...sivCLDetails, issues: modifiedIssues });
        setFilteredIssues(modifiedIssues);
        setConfirmExitValue(dispatch, true);
      } else {
        setSIVCLDetails({ ...sivCLDetails, issues: [] });
        setFilteredIssues([]);
        setConfirmExitValue(dispatch, true);
        dispatch(setMessage({ msgDetails: 'No Issues', severity: 'error' }));
      }
      setOpenImport(false);
    } else {
      let sivCLDetailsErrorModified = { ...sivCLDetailsError };
      if (
        sivCLDetails?.visit_confirmation?.siv_visit_start_date == null ||
        sivCLDetails?.visit_confirmation?.siv_visit_start_date === 'Invalid Date' ||
        ((sivCLDetailsError?.siv_visit_start_date == false || sivCLDetailsError?.siv_visit_start_date == null) &&
          sivCLDetails?.visit_confirmation?.siv_visit_start_date == null &&
          sivCLDetails?.visit_confirmation?.siv_visit_start_date == 'Invalid Date')
      ) {
        sivCLDetailsErrorModified = { ...sivCLDetailsErrorModified, siv_visit_start_date: true };
      }
      if (
        sivCLDetails?.visit_confirmation?.siv_visit_end_date == null ||
        sivCLDetails?.visit_confirmation?.siv_visit_end_date === 'Invalid Date' ||
        ((sivCLDetailsError?.siv_visit_end_date == false || sivCLDetailsError?.siv_visit_end_date == null) &&
          sivCLDetails?.visit_confirmation?.siv_visit_end_date == null &&
          sivCLDetails?.visit_confirmation?.siv_visit_end_date == 'Invalid Date')
      ) {
        sivCLDetailsErrorModified = { ...sivCLDetailsErrorModified, siv_visit_end_date: true };
      }
      setSIVCLDetailsError({ ...sivCLDetailsError, ...sivCLDetailsErrorModified });
      dispatch(setMessage({ msgDetails: 'Mandatory information is missing', severity: 'error' }));
    }
  };

  const getServerDateOrInvalid = (newDateValue: any) => {
    return String(newDateValue.$d) !== 'Invalid Date'
      ? moment(newDateValue.$d).format(SERVER_DATE_FORMAT)
      : String(newDateValue.$d);
  };

  const handlePublishSIVCL = () => {
    if (publishSIVCLPermission) {
      publishSivConfrimationLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        monitoring_visit_id: sivCLDetails?.visit_confirmation?.monitoring_visit_id,
        time_zone_id: UI_TIME_ZONE,
        publish_doc_version:
          sivCLDetails?.visit_confirmation?.siv_confirmation_publish_version >= '1.0'
            ? Math.floor(sivCLDetails?.visit_confirmation?.siv_confirmation_publish_version + 1)
            : '1.0',
        is_published: true,
        update: isUpdatePublish
      });
    }
    setDisableBtn(true);
  };

  const printSIVCL = async () => {
    try {
      dispatch(showLoader());
      const options = {
        monitoring_visit_id: sivCLDetails?.visit_confirmation?.monitoring_visit_id,
        template_name: 'site_initiation_visit_confirmation_letter',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          time_zone_id: UI_TIME_ZONE,
          country: selectedCountry,
          appName: `${archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP}`
        }
      };
      printPdfWithViewer('get_imvChecklist_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
    setConfirmExitValue(dispatch, false);
  };

  const handleEmailActivity = () => {
    setOpenEmailPopoup(true);
  };

  useEffect(() => {
    if (publishSivConfrimationLetterIsSuccess && !publishSivConfrimationLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Successfully published to eTMF',
          severity: 'success'
        })
      );
      getSIVConfrimationLetterData();
      setIsChanged(false);
    }
  }, [publishSivConfrimationLetterIsLoading, publishSivConfrimationLetterIsSuccess]);

  useEffect(() => {
    if (updateSivConfrimationLetterIsError || publishSivConfrimationLetterIsError || createNewVersionIsError) {
      const err: any = updateSivConfrimationLetterError || publishSivConfrimationLetterError || createNewVersionError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      }
    }
  }, [updateSivConfrimationLetterIsError, createNewVersionIsError]);

  useEffect(() => {
    if (updateSivConfrimationLetterIsSuccess && !updateSivConfrimationLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Data updated successfully',
          severity: 'success'
        })
      );
      getSIVConfrimationLetterData();
      setOpenRTEContent(false);
      setDisableEditContent(false);
      setIsChanged(false);
    }
  }, [updateSivConfrimationLetterIsLoading, updateSivConfrimationLetterIsSuccess]);

  useEffect(() => {
    if (selectedSite === null) {
      handleBack();
    }
  }, [studyId, selectedCountry, selectedSite]);

  const handleChangeTextEditor = (htmlContext: any, planetext: any) => {
    setHtmlContent(htmlContext);
  };

  const handleEditRTE = (content: string) => {
    setOpenRTE(true);
    setOpenRTEContent(true);
  };
  const handleSaveRTE = (content: string) => {
    setOpenRTE(false);
    setDisableEditContent(true);
    setIsChanged(true);
  };

  const handleCreateNewVersion = () => {
    setOpenVersionPopup(true);
    setDisableBtn(true);
  };

  const handleCreateNewSIVversion = () => {
    createNewVersion({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      sq_visit_id: selectedRow?.id,
      application_section: selectedAppSection
    });
    setOpenVersionPopup(false);
  };

  return (
    <>
      <Loader />
      <Box className="mainBackBtnWrap">
        <Button onClick={handleBack} startIcon={<ArrowBackIcon fontSize="small" />}>
          SIV Confirmation Letter List
        </Button>
      </Box>
      <Grid container spacing={1} sx={{ mb: 1.5, alignItems: 'center' }}>
        <Grid item>
          <Typography variant="h5" component="h5" sx={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>
            {selectedRow?.visit_name}
          </Typography>
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            {archLevel === 'sponsor' && (
              <Button
                variant="contained"
                style={{ textTransform: 'none' }}
                sx={{ alignSelf: 'center' }}
                disabled={
                  (archLevel === 'sponsor' && !publishSIVCLPermission) ||
                  disableBtn ||
                  !selectSivConfrimationLetterData?.visit_confirmation?.siv_salutation_letter
                    ? true
                    : selectSivConfrimationLetterData?.visit_confirmation?.is_published || selectSivConfrimationLetterData?.visit_confirmation?.is_published==null || (isChanged && !disableBtn)
                }
                onClick={handlePublishSIVCL}
              >
                PUBLISH TO eTMF
              </Button>
            )}
            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                disabled={
                  !checkPermission('create_new_version_siv_confirmation_letter') ||
                  selectSivConfrimationLetterData?.visit_confirmation?.is_published !== true
                }
                onClick={handleCreateNewVersion}
              >
                Create new version
              </Button>
            )}
            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                onClick={handleSaveSIVCL}
                disabled={
                  !updateSICLPermission || !isChanged
                    ? true
                    : selectSivConfrimationLetterData?.visit_confirmation?.is_published
                }
              >
                Save
              </Button>
            )}
            <IconButton
              aria-label="Print"
              color="primary"
              sx={{ alignSelf: 'center' }}
              onClick={() => printSIVCL()}
              disabled={!selectSivConfrimationLetterData?.visit_confirmation?.is_published}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {archLevel === 'sponsor' && (
              <IconButton
                aria-label="Send"
                color="primary"
                sx={{ alignSelf: 'center' }}
                onClick={() => handleEmailActivity()}
                disabled={
                  !checkPermission('email_sponsor_site_initiation_confirmation_letter') ||
                  !selectSivConfrimationLetterData?.visit_confirmation?.is_published
                }
              >
                <SendIcon />
              </IconButton>
            )}
          </Stack>
        </Grid>
      </Grid>

      <Box className="letterPage">
        <Typography gutterBottom color="text.secondary2">
          {getPreferredDateInLocal(selectedRow?.start_date)} <br />
          {siteStudyPersonnelsData?.site?.pi_first_name} {siteStudyPersonnelsData?.site?.pi_last_name} <br />
          {siteStudyPersonnelsData?.site?.site_name} <br />
          {siteStudyPersonnelsData?.site?.site_street_address1}
          {siteStudyPersonnelsData?.site?.site_street_address2 !== null
            ? `, ${siteStudyPersonnelsData?.site?.site_street_address2}`
            : ''}{' '}
          <br />
          {siteStudyPersonnelsData?.site?.site_city}
          {siteStudyPersonnelsData?.site?.site_state !== null ? `, ${siteStudyPersonnelsData?.site?.site_state}` : ''}
          {siteStudyPersonnelsData?.site?.site_zip_code !== null
            ? `, ${siteStudyPersonnelsData?.site?.site_zip_code}`
            : ''}
        </Typography>

        <dl className="text-Bold dlStyle">
          <dt>RE</dt>
          <dd>
            Protocol {siteStudyPersonnelsData?.study?.study_id}-{siteStudyPersonnelsData?.study?.study_title} <br />
            Site Initiation Visit Confirmation Letter <br />
            Site Number: {siteStudyPersonnelsData?.site?.site_id}
          </dd>
        </dl>

        <Typography sx={{ mb: 1, pt: 2 }}>
          Dear &nbsp;{' '}
          <span style={{ width: '220px', display: 'inline-block' }}>
            <TextField
              id="standard-error-helper-text"
              label="Salutation"
              variant="standard"
              name="siv_salutation_letter"
              className="fieldRequired"
              inputProps={{ maxLength: 50 }}
              value={sivCLDetails?.visit_confirmation?.siv_salutation_letter || ''}
              onChange={e => handleChange(e)}
              error={salulationErr}
              disabled={!updateSICLPermission || selectSivConfrimationLetterData?.visit_confirmation?.is_published}
              helperText={salulationErr && 'Required'}
              sx={{ mt: '-16px !important' }}
            />
          </span>
          &nbsp; {siteStudyPersonnelsData?.site?.pi_first_name} {siteStudyPersonnelsData?.site?.pi_last_name},
          <br />
        </Typography>
        <Typography gutterBottom>
          This letter is to confirm that I will be conducting a Site Initiation Visit at your site on{' '}
          {selectedRow?.start_date && moment(`${selectedRow?.start_date}Z`).format('dddd')},{' '}
          {getPreferredDateInLocal(selectedRow?.start_date)} for the above-mentioned study. I plan to arrive at
          approximately {selectedRow?.start_date && moment(`${selectedRow?.start_date}Z`).format('LT').toLowerCase()},
          with various appointments scheduled throughout the morning/afternoon/day.
        </Typography>
        {editSIVCLPermission && selectSivConfrimationLetterData?.visit_confirmation?.is_published !== true ? (
          <Paper variant="outlined" sx={{ position: 'relative', my: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: 1.5, px: 2 }}>
              <Typography variant="subtitle1">Editable Content</Typography>
              {openRTE ? (
                <Button variant="contained" size="small" color="primary" onClick={() => handleSaveRTE('content')}>
                  SAVE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={disableEditContent}
                  onClick={() => handleEditRTE('content')}
                >
                  EDIT
                </Button>
              )}
            </Box>
            <Divider variant="middle" sx={{ mx: 0 }} />
            <Box className="editRTEBox" p={2}>
              {openRTEContent ? (
                <MainRTE
                  log={(htmlContext: any, planetext: any) => handleChangeTextEditor(htmlContext, planetext)}
                  value={validationOfRTE}
                  placeholder={'Enter Value'}
                  height={400}
                  disabled={disableEditContent}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: validationOfRTE
                  }}
                />
              )}
            </Box>
          </Paper>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: validationOfRTE
            }}
          />
        )}

        <p style={{ marginBottom: 8 }}>Please also be prepared to resolve the following outstanding issues:</p>
        {filteredIssues?.length > 0 && (
          <TableContainer sx={{ my: 2 }}>
            <Table aria-label="collapsible table" className="table table-bordered table-column-bordered">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ minWidth: 120 }}>
                    <b>Subject ID</b>
                  </TableCell>
                  <TableCell>
                    <b>Category</b>
                  </TableCell>
                  <TableCell sx={{ minWidth: 120 }}>
                    <b>Issue Class</b>
                  </TableCell>
                  <TableCell sx={{ minWidth: 120 }}>
                    <b>Issue</b>
                  </TableCell>
                  <TableCell>
                    <b>Action Description</b>
                  </TableCell>
                  <TableCell>
                    <b>Action Due Date</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredIssues.length ? (
                  filteredIssues?.map((row: any) => (
                    <TableRow key={row.id}>
                      <TableCell>{row.stdy_siv_subject_id}</TableCell>
                      <TableCell>{row.stdy_siv_category}</TableCell>
                      <TableCell>{row.stdy_siv_issue_class}</TableCell>
                      <TableCell>{row.stdy_siv_issues}</TableCell>
                      <TableCell>{row.stdy_siv_action_description}</TableCell>
                      <TableCell>
                        {row.stdy_siv_action_due_date !== null
                          ? moment(row.stdy_siv_action_due_date).format(userPreferedDateFormat.toUpperCase())
                          : null}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow key={1}>
                    <TableCell colSpan={6}>No issues found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <Button
          variant="contained"
          sx={{ mb: 2 }}
          onClick={handleClickOpenImport}
          disabled={!updateSICLPermission || selectSivConfrimationLetterData?.visit_confirmation?.is_published}
        >
          Import
        </Button>

        <Typography gutterBottom>
          I look forward to meeting you and your study team. If you have any questions, please do not hesitate to
          contact me on {sivCLDetails?.visit_confirmation?.siv_cra_phone_number} or e-mail{' '}
          {sivCLDetails?.visit_confirmation?.siv_cra_email_address}.
        </Typography>

        <Typography gutterBottom>
          Yours sincerely, <br />
          {sivCLDetails?.visit_confirmation?.siv_cra_first_name
            ? sivCLDetails?.visit_confirmation?.siv_cra_first_name
            : userFullName}{' '}
          <br />
          <span color="text.secondary">{sponsor?.toUpperCase()}</span>
        </Typography>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Share'}</DialogTitle>
        <DialogContent sx={{ minWidth: '600px' }}>
          <TextField id="name-email" label="Enter Name or Email" variant="standard" fullWidth sx={{ mb: 1.5 }} />

          <TextField
            id="send-message"
            label="Type your message here.."
            variant="standard"
            fullWidth
            multiline
            rows={4}
            maxRows={4}
            margin="normal"
          />
          <br />
          <br />
          <br />
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2} sx={{ justifyContent: 'space-between' }}>
            <Grid item xs>
              <Button
                size="small"
                startIcon={<LinkIcon />}
                sx={{ ml: 2 }}
                className="nouppercase-btn"
                onClick={() => navigator.clipboard.writeText('URL copied..')}
              >
                Copy Shareable Link
              </Button>
            </Grid>
            <Grid item>
              <Button onClick={handleClose} className="grey-btn">
                Close
              </Button>
              <Button onClick={handleClose} autoFocus>
                Share
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <PopupComponent open={openImport} sx={{ '@media (max-width:1367px)': { marginTop: '-136px' } }}>
        <DialogTitle id="alert-dialog-title">{'Import'}</DialogTitle>
        <DialogContent sx={{ minWidth: '600px' }}>
          <Grid container spacing={2} className="event-form">
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel
                  required
                  id="selectVisit"
                  sx={{
                    '&[data-shrink="false"]': { transform: 'translate(0, 16px) scale(1)' },
                    '&[data-shrink="true"]': { transform: 'translate(0, -9px) scale(0.75)' }
                  }}
                >
                  Visit
                </InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Visit"
                  defaultValue={'10'}
                  onChange={handleChange}
                >
                  <MenuItem value={'10'}>{selectedRow?.visit_name}</MenuItem>
                </Select>
              </FormControl>

              <Grid />
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    inputFormat={dateFormat}
                    label="Start Date"
                    value={preferedFormatForDatePicker(sivCLDetails?.visit_confirmation?.siv_visit_start_date)}
                    maxDate={preferedFormatForDatePicker(sivCLDetails?.visit_confirmation?.siv_visit_end_date)}
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        setSIVCLDetails({
                          ...sivCLDetails,
                          visit_confirmation: {
                            ...sivCLDetails?.visit_confirmation,
                            siv_visit_start_date: getServerDateOrInvalid(newValue)
                          }
                        });
                        setSIVCLDetailsError({
                          ...sivCLDetailsError,
                          siv_visit_start_date: false
                        });
                      } else {
                        setSIVCLDetailsError({
                          ...sivCLDetailsError,
                          siv_visit_start_date: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        error={sivCLDetailsError?.siv_visit_start_date}
                        helperText={sivCLDetailsError?.siv_visit_start_date ? 'Required' : ''}
                        required
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    inputFormat={dateFormat}
                    label="End Date"
                    value={preferedFormatForDatePicker(sivCLDetails?.visit_confirmation?.siv_visit_end_date)}
                    minDate={preferedFormatForDatePicker(sivCLDetails?.visit_confirmation?.siv_visit_start_date)}
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        setSIVCLDetails({
                          ...sivCLDetails,
                          visit_confirmation: {
                            ...sivCLDetails?.visit_confirmation,
                            siv_visit_end_date: getServerDateOrInvalid(newValue)
                          }
                        });
                        setSIVCLDetailsError({
                          ...sivCLDetailsError,
                          siv_visit_end_date: false
                        });
                      } else {
                        setSIVCLDetailsError({
                          ...sivCLDetailsError,
                          siv_visit_end_date: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        error={sivCLDetailsError?.siv_visit_end_date}
                        helperText={sivCLDetailsError?.siv_visit_end_date ? 'Required' : ''}
                        required
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImport} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleImportSumbit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setSIVConfirmLetterOpen(true);
              setStudyLogOpen(false);
              setIsChanged(false);
              setNTFGrid(true);
              setopenSIVConfLetter(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent aria-labelledby="customized-dialog-title" open={openVersionPopup} maxWidth="lg">
        <DialogTitle> Please Confirm</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Are you sure you want to create a new version?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={() => setOpenVersionPopup(!openVersionPopup)}>
            Cancel
          </Button>
          <Button onClick={handleCreateNewSIVversion}>Create</Button>
        </DialogActions>
      </PopupComponent>
      {openEmailPopoup && (
        <EmailActivity
          openEmailPopoup={openEmailPopoup}
          setOpenEmailPopoup={setOpenEmailPopoup}
          documentDetails={documentOnTmfDocumentIdData}
          permission={'UPDATE_SITEINITIATION_CONFIRMATIONLETTER'}
        />
      )}
    </>
  );
};

export default SiteInitiationConfirmationLetter;
